import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import LocationChartReport from "./LocationChartReport";
import GeneralUtils from "../../../shared/utils/GeneralUtils";

export default class LocationReport extends React.Component {
    render() {
        return (
            <Container>
                {GeneralUtils.checkPrivilege('LocationReport', 'View') &&
                <Row>
                    <Col>
                        <LocationChartReport/>
                    </Col>
                </Row>
                }
            </Container>
        );
    }
}
